export const additionalChargesTab = {
  loading: "جارٍ تحميل الإعدادات…",
  tax: {
    title: "الضريبة (ضريبة القيمة المضافة)",
    tag: "مشمولة في السعر",
    description:
      "ضريبة القيمة المضافة <b>مشمولة</b> بالفعل في أسعار تعرفاتك. هنا تحدد فقط النسبة التي تُفصَّل في الإيصال والفاتورة — <b>ولا تُضاف إلى الإجمالي</b>.",
    hint: "الحقل الفارغ = تُستخدَم ضريبة القيمة المضافة الخاصة بمُصدِر الفوترة المعيَّن. تنطبق على الحجوزات المباشرة فقط.",
  },
  cleaning: {
    title: "رسوم التنظيف",
    tag: "ثابتة",
    description: "مبلغ ثابت لكل إقامة. إذا كان <b>0</b>، فلا يُطبَّق.",
    showToGuest: "عرضها في ملخّص الحجز",
  },
  charges: {
    title: "رسوم إضافية",
    summary: "{count} رسم مُعَدّ. | {count} رسوم مُعَدّة.",
    summaryEmpty: "أنشئ رسومًا اختيارية (لكل حجز أو لكل شخص أو لكل ليلة).",
    addButton: "إضافة رسم",
    empty: "لا توجد رسوم إضافية بعد.",
    headers: {
      title: "العنوان",
      method: "طريقة الاحتساب",
      value: "القيمة",
      visible: "مرئي",
    },
    titlePlaceholder: "مثال: ضريبة السياحة",
    removeTitle: "حذف",
    hint: "تظهر الرسوم المرئية كبند منفصل للنزيل عند الدفع؛ أمّا الباقي فيُضاف إلى الإجمالي.",
  },
  methods: {
    perStay: "مبلغ لكل حجز",
    perNight: "مبلغ لكل ليلة",
    perPerson: "مبلغ لكل شخص",
    perPersonPerNight: "مبلغ لكل شخص وليلة",
    percent: "% من إجمالي الحجز",
  },
  validation: {
    cleaningInvalid: "يجب أن يكون مبلغ التنظيف رقمًا صالحًا وموجبًا.",
    taxRange: "يجب أن تكون ضريبة القيمة المضافة بين 0 و100%.",
    chargeTitleRequired: "يحتاج كل رسم إضافي إلى عنوان.",
    chargeValueInvalid: 'قيمة الرسم "{title}" غير صالحة.',
    chargePercentMax: 'لا يمكن أن تتجاوز نسبة الرسم "{title}" 100%.',
  },
  toasts: {
    saveSuccess: "تم حفظ الرسوم الإضافية بنجاح.",
    saveError: "تعذّر حفظ الرسوم الإضافية.",
  },
};
